module.exports = __webpack_public_path__ + "static/img/icon08.335b07fd.png";